import React, { useEffect, useState } from 'react';
import WebView from 'react-native-webview';
import { Platform } from 'react-native';
import { MEDEX } from '@env';
import { useAuth } from '~/auth/legacy/useAuth';
import { instanceApi } from '~/App';

interface PatientDataType {
  document: string;
}

export const MedexWebView = ({ document }: PatientDataType): JSX.Element => {
  const { onixCode, user } = useAuth();
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    const postData = async () => {
      try {
        const result = await instanceApi.sendDataHealthyHabitsUser(
          user?.name || '',
          document.replace(/\D+/g, ''),
          onixCode?.onixCode || '',
          user?.phone1 || user?.phone2 || '',
          user?.birthdate || '',
        );
        setUrl(`${MEDEX}/${result?.data?.id}`);
      } catch (error) {
        console.error('Erro ao obter URL da WebView:', error);
        setUrl('');
      }
    };

    void postData();
  }, [document, onixCode, user]);

  return Platform.OS !== 'web' ? (
    <WebView
      nestedScrollEnabled={true}
      scrollEnabled={true}
      javaScriptEnabled={true}
      overScrollMode="always"
      source={{ uri: url }}
      style={{ flex: 1, minHeight: 200, height: 650, opacity: 0.99 }}
    />
  ) : (
    <iframe
      src={url}
      style={{ width: '100%', height: '80vh', border: 'none' }}
      allow="camera; microphone"
    />
  );
};
